"use client";

export function getCurrentRedirectTarget(fallback = "/") {
  if (typeof window === "undefined") return fallback;
  const path = `${window.location.pathname || "/"}${window.location.search || ""}${window.location.hash || ""}`;
  return path || fallback;
}

export function buildLoginRedirect({ redirectTo, intent } = {}) {
  const target = redirectTo || getCurrentRedirectTarget("/");
  const params = new URLSearchParams();
  params.set("redirect", target);
  if (intent) params.set("intent", intent);
  return `/login?${params.toString()}`;
}

export function requireSignedIn(user, router, { intent, redirectTo } = {}) {
  if (user?.uid) return true;
  const href = buildLoginRedirect({ redirectTo, intent });
  if (router?.push) router.push(href);
  else if (typeof window !== "undefined") window.location.assign(href);
  return false;
}
